import React from 'react';
import PropTypes from 'prop-types';

import './CircledValueIcon.scss';

const CircledValueIcon = ({ value, width, height }) => (
  <svg
    viewBox="0 0 40 40"
    className="circled-value-icon"
    width={width || 40}
    height={height || 40}
  >
    <g>
      <circle r="46%" cx="50%" cy="50%" />
      <text x="50%" y="50%" textAnchor="middle" dy="0.35em">
        {value}
      </text>
    </g>
  </svg>
);

CircledValueIcon.propTypes = {
  value: PropTypes.string,
};

export default CircledValueIcon;
